export default __webpack_public_path__ + "static/imgAlloypng-aabd458dd4ca624c95385640920cfe72.png";